export const keywordWizardSettings = {
  claim_interval_required: false,
  point_value_required: true,
  show_contests: true,
  show_text: false,
  time_interval_required: false,
};
